import React from "react";
import { Image } from "react-native";

const PlayStore = ({ deepLink }: { deepLink: string }) => {
  return (
    <a
      href={
        deepLink ||
        "https://play.google.com/store/apps/details?id=com.fitme.ball"
      }
      style={{ textDecoration: "none", color: "unset" }}
    >
      <Image
        resizeMode={"contain"}
        source={require("../common/images/downloadAndroidBlack.png")}
        style={{ width: 140, height: 60 }}
      />
    </a>
  );
};

export default PlayStore;
